import React, { Component } from 'react'
import './camera-detail.less';
import { inject, observer } from 'mobx-react';
import { RProps } from '@/config/props';
import GlobalDeviceStore from '@/store/global-device';
import { Spin, Descriptions } from 'antd';
import { deviceException } from '@/interface/exception';
import { camera } from '@/interface/camera';
import { manageHistory } from '@/interface/dbox';
import { queryGlobalCameras } from '@/config/api/global-device';
import { cameraPtz, queryCameraDetail, queryCameraPlay, updateCamera } from '@/config/api/camera';
import { MobjectBaseType } from '@/utils/type';
import UserStore from '@/store/user-store';
import { globalInstall } from '@/interface/install';
import { ProjectContext } from '@/config/context';
import { queryMobjectDetail } from '@/config/api/mobject';
import DeviceFigure from '@/components/device/device-figure';
import { quantity } from '@/interface/quantity';
import { figureUploadUrl } from '@/config/api/document';
import JessibucaPlayer from "react-jessibuca";


interface IProps extends RProps {
    globalDeviceStore?: GlobalDeviceStore,
    userStore?: UserStore,
    // cameraStore?: CameraStore,
}
interface IState {
    cameraDetail: camera,
    cameraPlayUrl: string,
    statusHistory: manageHistory[],
    cameraExceptions: deviceException[],
    statusLoading: boolean,
    frequencyLoading: boolean,
    initializeLoading: boolean,
    gInstalls: globalInstall[],
    cameraFormulaTabKey: string,
    quantities: quantity[],


    dataLoading: boolean,
    cameraTestLoading: boolean
    cameraInitialLoading: boolean

    pageLoading: boolean

    autoFlushData: boolean
    videoWidth: number
    mode: string
}

@inject('routeStore', 'globalDeviceStore', 'userStore')
@observer
export default class CameraDetailPage extends Component<IProps, IState> {
    static contextType = ProjectContext;
    state = {
        cameraDetail: null,
        cameraPlayUrl: "",
        statusHistory: [],
        cameraExceptions: [],
        statusLoading: false,
        frequencyLoading: false,
        initializeLoading: false,
        gInstalls: [],
        cameraFormulas: [],
        cameraFormulaTabKey: "0",
        cameraQuantities: [],
        quantities: [],



        cameraDataList: [],
        dataLoading: false,
        cameraTestLoading: false,
        cameraInitialLoading: false,

        pageLoading: false,

        autoFlushData: false,
        ws: null,
        flvPlayer: null,
        videoWidth: 1280,
        mode: 'day',  //TODO暂不支持白夜切换
    }
    cameraId: number;
    tab_uuid: string;
    jessibuca: any;
    timer: any;
    private myRef: React.RefObject<HTMLDivElement>;

    isAutoDataLoading = false;

    constructor(props) {
        super(props)
        let id = this.props.match.params['cameraId'];
        // console.log(id)
        this.tab_uuid = this.props.routeStore.addRoutePane(`摄像头${id}`, this.props.match.url);
        this.cameraId = id;
        this.myRef = React.createRef<HTMLDivElement>();
    }
    componentDidMount() {
        let id = this.props.match.params['cameraId'];
        this.generateData(id);
        if (this.myRef.current) {
            const width = this.myRef.current.offsetWidth;
            const height = this.myRef.current.offsetHeight;
            // console.log(`Width: ${width}, Height: ${height}`);
        }
        this.updateDimensions();
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
        // this.state.flvPlayer.pause();
        // this.state.flvPlayer.unload();
        // this.state.flvPlayer.detachMediaElement();
        // this.state.flvPlayer.destroy();
        // this.state.flvPlayer = null;

        // this.state.ws.close();
        window.removeEventListener('resize', this.updateDimensions);
    }

    componentDidUpdate() {
        let id = this.props.match.params['cameraId'];
        // console.log(id)
        this.tab_uuid = this.props.routeStore.addRoutePane(`摄像头${id}`, this.props.match.url);
        if (this.cameraId !== id) {
            this.cameraId = id;
            this.generateData(id);
        }
    }

    updateDimensions = () => {
        //修改video画面以适配实际页面大小
        const { current } = this.myRef;
        if (current) {
            const { width, height } = current.getBoundingClientRect();
            // console.log(`width=${width},height=${height}`);
            let videoElement = document.getElementById("videoElement");
            videoElement.style.width = `${width}px`
            videoElement.style.height = `${Math.ceil(width / 16 * 9)}px`
        }
    };



    generateData = (id) => {
        this.loadCamera(id);
    }

    loadCamera = (id: number) => {
        if (this.props.globalDeviceStore._globalCameras.length === 0) {
            // 如果未加载过全局设备，则先请求
            queryGlobalCameras().then(res => {
                // console.log(res.data);
                this.props.globalDeviceStore.globalCameras(res.data);
                this.findCameraDetail(id);
            })
        } else {
            this.findCameraDetail(id);
        }
    }

    move = (direction) => {
        //控制摄像头移动
        //转动参数需要${id},${水平方向},${垂直方向}三个参数
        let camera_id = this.state.cameraDetail.id;
        let params = { "direction": direction };
        cameraPtz(camera_id, null, params).then(res => {
            setTimeout(function () {
                cameraPtz(camera_id, null, { "direction": 'stop' }).then(res => {
                    console.log(res);
                })
            }, 1000)
        })
    }


    change_day_night = () => {
        //TODO
    }


    findCameraDetail = (id: number) => {
        this.setState({
            pageLoading: true,
        })

        queryCameraDetail(id)
            .then(res => {
                let cameraDetail: camera = res.data;
                // console.log(cameraDetail)
                this.setState({
                    cameraDetail: cameraDetail,
                })
                //todo
                if (cameraDetail) {
                    queryCameraPlay(id).then(res => {
                        // console.log(res.data.flv)
                        if(res.data && res.data.https_flv){
                            this.setState({
                                cameraPlayUrl: res.data.https_flv.replace(/47.100.117.212:7443/g, "flv.tncet.com"), //TODO 暂时这样使其能够播放，本地化需要修改
                            })
                            setTimeout(() => {
                                this.updateDimensions();
                            }, 2000)
                        }
                    })
                }
                this.props.routeStore.changeRoutePaneName(this.tab_uuid, `摄像头${cameraDetail?.camera_id}`);
            }).finally(() => {
                this.setState({
                    pageLoading: false,
                })
            })
    }

    saveCameraFigure = (url) => {
        updateCamera(this.cameraId, {
            figure_url: url
        }).then(res => {
            this.state.cameraDetail.figure_url = url;
            this.setState({
                cameraDetail: { ...this.state.cameraDetail }
            })
        })
    }

    gotoMobjectQuantityDetail = () => {
        let cameraDetail = this.state.cameraDetail;
        let mobjectId = cameraDetail.mobject_id;
        if (!mobjectId) return;
        queryMobjectDetail(mobjectId, {
            project_id: this.context,
        }).then(res => {
            let m = res.data;
            let typeName = MobjectBaseType[m.type]['name'];
            let url = `/projects/${this.context}/mobjects/${typeName}/${mobjectId}?tab=2`;
            this.props.history.push(url);
        })
    }

    gotoAnotherCamera = (id: number) => {
        if (!id) return;
        let url = `/projects/${this.context}/cameras/${id}`;
        this.props.routeStore.changeRoutePaneUrl(this.tab_uuid, url);
        this.props.history.push(url);
    }
    //jessibuca视频播放器
    initJessibucaPlayer() {
        let url = this.state.cameraPlayUrl;
        return (
            url &&
            <JessibucaPlayer 
        
                 src={url}
                decoder='../../../decoder.js'
                objectFit='fill'
                config={{}}

                mute
                onLoad={() => { console.log('load'); }}
                onPlay={() => { console.log('play'); }} />
        )
    }

    render() {
        let { cameraDetail } = this.state;
        if (!cameraDetail || this.state.pageLoading) {
            return <Spin size="large" />;
        }
        return (
            <div className="camera-detail-container">
                <div className="camera-video-container">
                    <div ref={this.myRef} className="camara-video-div">
                        <div id="videoElement" style={{width:`${this.state.videoWidth}px`, height:`${Math.ceil(this.state.videoWidth/16*9)}px`}} >
                        {this.initJessibucaPlayer()}
                        </div>

                    </div>
                    <div className='camara-video' id='vedioContainer'></div>
                    <div className="camera-control-container">
                        {/* 
                        TODO
                        <button className="btn btn-primary" onClick={() => {  }}>接收画面</button>
                        <button className="btn btn-primary" onClick={() => {  }}>暂停画面</button>
                        <button className="btn btn-primary" onClick={() => { this.change_day_night() }}>白夜切换</button>
                        */}
                        <button className="btn btn-primary" onClick={() => { this.move("left") }}>←</button>
                        <button className="btn btn-primary" onClick={() => { this.move("up") }}>↑</button>
                        <button className="btn btn-primary" onClick={() => { this.move("down") }}>↓</button>
                        <button className="btn btn-primary" onClick={() => { this.move("right") }}>→</button>
                    </div>
                </div>
                <div className="camera-message-container">
                    <div className="camara-title">基本信息</div>
                    <Descriptions
                        column={1}>
                        <Descriptions.Item label="名称">
                            <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{cameraDetail.name}</span>
                        </Descriptions.Item>
                        <Descriptions.Item label="相机编号">
                            <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{cameraDetail.camera_id}</span>
                        </Descriptions.Item>
                        <Descriptions.Item label="型号">
                            <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{cameraDetail.marking}</span>
                        </Descriptions.Item>
                        <Descriptions.Item label="厂家">
                            {cameraDetail.manufacturer}
                        </Descriptions.Item>
                        {/* <Descriptions.Item label="控制协议">
                            {cameraDetail.protocol}
                        </Descriptions.Item> */}
                        {/* <Descriptions.Item label="相机编号">{cameraDetail.camera_id}</Descriptions.Item> */}
                        <Descriptions.Item label="现场照片">{ }</Descriptions.Item>
                    </Descriptions>
                    <div className="camera-scene-photo">
                        <DeviceFigure
                            uploadUrl={figureUploadUrl}
                            imgUrl={cameraDetail.figure_url}
                            afterUpload={this.saveCameraFigure} />
                    </div>
                </div>
            </div>
        )
    }
}
